import React from 'react'
import { connect } from 'react-redux'
import { REDUCER, submit, change, googleSignInSuccess, googleSignInFailure } from 'ducks/login'
import Form from 'antd/lib/form'
import Icon from 'antd/lib/icon'
import Input from 'antd/lib/input'
import Button from 'antd/lib/button'
import Alert from "antd/lib/alert"

import l8n, { e } from 'l8n'
import { getGeoipCountry } from 'scripts/geoip';
import LocaleDropdown from 'components/CustomComponents/Localization/LocaleDropdown'
import Link from 'components/CustomComponents/Localization/Link'
import GoogleSignIn from 'components/CustomComponents/SignIn/Google'
import { AuthPolicy } from 'components/CleanComponents/AuthPolicy/index'

const FormItem = Form.Item

const mapStateToProps = (state, props) => ({
  formSubmitted: state.app.submitForms[REDUCER],
  data: state.login.data,
  googleSignUpErrorMessage: state.login.googleSignUpErrorMessage,
});

@connect(mapStateToProps)
@Form.create({
  onFieldsChange(props, changedFields) {
    props.dispatch(change(changedFields))
  },
  mapPropsToFields(props) {
    return {
      email: Form.createFormField({ ...props.data.email, value: props.data.email.value }),
      password: Form.createFormField({ ...props.data.password, value: props.data.password.value }),
    }
  }
})
class LoginFormFields extends React.Component {
  state = {
    country: null
  }

  componentDidMount() {
    getGeoipCountry().then(country => this.setState({country}));
  }

  onSubmit = (formSubmitted) => event => {
    event.preventDefault()
    const { form, dispatch } = this.props
    if (!formSubmitted) {
      form.validateFields((error, values) => {
        if (!error) {
          dispatch(submit(values))
        }
      })
    }
  }

  onSuccessCallback({ idToken }) {
    this.props.dispatch(googleSignInSuccess({ idToken }));
  }

  onFailCallback() {
    this.props.dispatch(googleSignInFailure(l8n.p_wrong_password));
  }

  render() {
    const { form, formSubmitted, googleSignUpErrorMessage } = this.props;
    const onSuccessCallback = this.onSuccessCallback.bind(this);
    const onFailCallback = this.onFailCallback.bind(this);
    return (
      <React.Fragment>
        {!['RU', null].includes(this.state.country) ? (
        <React.Fragment>
          <GoogleSignIn
            onSuccessCallback={onSuccessCallback}
            onFailCallback={onFailCallback}
            buttonPrefix={l8n.sign_in_with}
          />
          {googleSignUpErrorMessage && <Alert
            message={googleSignUpErrorMessage}
            type="error"
          />}
          <div
            style={{ width: '100%', textAlign: 'center', margin: '20px 0 10px' }}
          >
            {l8n.or}
          </div>
        </React.Fragment>
        ) : null}
        <Form className="auth-form" hideRequiredMark onSubmit={this.onSubmit(formSubmitted)}>
          <FormItem>
            {form.getFieldDecorator('email', {
              rules: [
                { type: 'email', message: e(l8n.p_correctEmail) },
                { required: true, message: e(l8n.p_required) },
              ],
            })(
              <Input
                prefix={<Icon type="user"  style={{ fontSize: '14px', color: 'rgba(0,0,0,.25)' }}/>}
                placeholder={l8n.p_email}
                className="ant-input-lg"
                data-qa-id="login-email-input"
              />,
            )}
          </FormItem>
          <FormItem>
            {form.getFieldDecorator('password', {
              rules: [{ required: true, message: e(l8n.p_required) }],
            })(
              <Input
                prefix={<Icon type="lock" style={{ fontSize: '14px', color: 'rgba(0,0,0,.25)' }}/>}
                type="password"
                placeholder={l8n.p_password}
                className="ant-input-lg"
                data-qa-id="login-password-input"
              />,
            )}
          </FormItem>
          <FormItem>
            <Link to="/password-recovery" className="auth-form-forgot pull-right text-primary" qaId="login-password-recovery-link" style={{ lineHeight: '36px' }}>
              {l8n.p_passwordRecovery}
            </Link>
          </FormItem>
          <div className="form-actions">
            <div style={{float: 'right', marginTop: 5}}>
              <LocaleDropdown/>
            </div>
            <Button type="primary" htmlType="submit" className="auth-form-button" data-qa-id="login-submit-button" loading={formSubmitted}>
              {l8n.p_login}
            </Button>
            <span className="ml-3 register-link">
              <Link to="/autoreg" className="text-primary utils__link--underlined" qaId="login-register-link">
                {l8n.p_register}
              </Link>
            </span>
          </div>
          <AuthPolicy/>
        </Form>
      </React.Fragment>
    )
  }
}

export default LoginFormFields



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Form/LoginForm/index.js